export const environment = {
  production: false,
  pollingInterval: 10_000,
  authConfig: {
    scope: 'openid profile email address bmwids organization b2xroles',
    responseType: 'code id_token token',
    redirectUri: window.location.origin + '/',
    silentRefreshRedirectUri: window.location.origin + '/',
    requireHttps: false,
    strictDiscoveryDocumentValidation: false,
    useHttpBasicAuth: true,
    skipIssuerCheck: true,
    silentRenew: true,
    useRefreshToken: true,
    showDebugInformation: true,
  },
};
